export default "__VITE_ASSET__BVmYF6nU__"